/**
 * The one thing a host has to mount.
 *
 * Everything the module needs from its host arrives through here: the base URL, a way to
 * get a token, and optionally a way to build deep links into the applications that own the
 * mirrored masters.
 *
 * The provider does NOT create a `QueryClient`. The host already has one — all three MUI
 * hosts wrap their app in a `QueryClientProvider` — and a module that installed a second
 * one would give itself a private cache that the host's devtools cannot see and the host's
 * sign-out cannot clear.
 */
import { createContext, createElement, useContext, useMemo } from 'react';
import { InventoryClient } from '../api/client.js';
const InventoryContext = createContext(null);
export function InventoryProvider(props) {
    const { children, links } = props;
    const injected = props.client;
    const config = props.config;
    const value = useMemo(() => {
        const client = injected ?? new InventoryClient(config);
        return { client, links: links ?? {} };
    }, [injected, config, links]);
    return createElement(InventoryContext.Provider, { value }, children);
}
export function useInventoryContext() {
    const value = useContext(InventoryContext);
    if (!value) {
        throw new Error('useInventoryContext must be used inside <InventoryProvider>. Mount it once, above ' +
            "the module's routes, and give it a baseUrl and a getToken from the host's own session.");
    }
    return value;
}
export function useInventoryClient() {
    return useInventoryContext().client;
}
export function useHostLinks() {
    return useInventoryContext().links;
}
//# sourceMappingURL=provider.js.map